import script from "./CEOMember.vue?vue&type=script&setup=true&lang=js"
export * from "./CEOMember.vue?vue&type=script&setup=true&lang=js"

import "./CEOMember.vue?vue&type=style&index=0&id=9e5cb670&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e5cb670"]])

export default __exports__